import React from "react";
import { compose } from 'redux';
import { withStyles } from '@material-ui/styles';

import ButtonLink from "../../../../base/links/button_link.js.jsx";

import withCurrentUser from '../../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../../hocs/with_show_toast.js.jsx';
import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js.jsx';

import pageStyles from "../../../styles/page_styles.js.jsx";

import ListDownloadablesUseCase from "../../../../use_cases/admin/downloadables/list_downloadables_use_case.js.jsx";
import { DownloadableModel } from "../../../../models/downloadables/downloadable_model.js.jsx";

import BaseListPage from "../../base_list_page.js.jsx";

import Routes from "../../../routes.js.jsx";

const styles = theme => ({
});

class DownloadablesListPage extends BaseListPage {

  headerContent() {
    const { classes } = this.props;
    return <React.Fragment>
      <ButtonLink className = { classes.button }
                  to = { Routes.downloadable("new") } >
        { I18n.t("admin.downloadable.action.new") }
      </ButtonLink>
    </React.Fragment>
  }

}

DownloadablesListPage.defaultProps = {
  dataModel: DownloadableModel,
  listUseCase: ListDownloadablesUseCase
}

export default compose(
  withLocationSearchFilter,
  withShowToast,
  withCurrentUser,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(DownloadablesListPage);
